import { AuxiliumComponent } from "../auxilium-component";

export default class DropdownItem extends AuxiliumComponent {
	static observable = ["value", "link", "group", "suffix-icon", "icon", "icon-colour", "variation", "target", "download", "helper-text"];
	static observableBooleans = ["detached", "loading"];

	#OriginalIcon = "";

	parsedCallback() {
		if (this.icon) { this.prepend(document.createElementWithContents("chip-icon", null, { icon: this.icon, className: "dropdown-item__icon", colour: this.iconColour })); }
		if (this.helperText) { this.appendChild(document.createElementWithContents("span", this.helperText, { className: "dropdown-item__helper-text" })); }
		if (this.suffixIcon) { this.appendChild(document.createElementWithContents("chip-icon", null, { icon: this.suffixIcon, className: "dropdown-item__suffix-icon" })); }

		this.#OriginalIcon = this.icon;
		this.#SetLoading(this.loading);
	}

	#SetLoading(isLoading) {
		if (isLoading) {
			this.#OriginalIcon = this.icon;
			this.icon = "fad fa-spinner-third spin";
		} else {
			this.icon = this.#OriginalIcon;
		}

		this.disabled = isLoading;
	}

	attributeChanged(name, _, newValue) {
		switch (name) {
			case "disabled":
				if (!this.parentElement.classList.contains("dropdown-item--interactable")) { return; }

				if (!this.IsAttributeValueTrue(newValue)) {
					this.parentElement.removeAttribute("disabled");
				} else {
					this.parentElement.setAttribute("disabled", "");
				}
				break;
			case "link":
				if (this.parentElement.nodeName === "A") {
					this.parentElement.href = newValue;
				}
				break;
			case "suffix-icon":
				this.querySelector(":scope > .dropdown-item__suffix-icon")?.remove();

				if (newValue) {
					this.appendChild(document.createElementWithContents("chip-icon", null, { icon: newValue, className: "dropdown-item__suffix-icon" }));
				}
				break;
			case "icon":
				this.querySelector(":scope > .dropdown-item__icon")?.remove();

				if (newValue) {
					this.prepend(document.createElementWithContents("chip-icon", null, { icon: newValue, className: "dropdown-item__icon", colour: this.iconColour }));
				}
				break;
			case "loading":
				this.#SetLoading(this.IsAttributeValueTrue(newValue));
				break;
		}
	}
}
